import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const UserGroup_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.1018 16.4011C18.0946 16.518 18.0909 16.6359 18.0909 16.7547C18.0909 19.06 19.4726 21.0237 21.45 21.9464C20.0393 22.393 18.8707 23.2093 17.9825 24.268C18.5609 24.6282 19.0411 25.1314 19.3735 25.7282C20.3863 24.42 21.9397 23.5661 24 23.5661C26.4362 23.5661 28.1636 24.7601 29.1266 26.487C29.3956 26.9694 30.0046 27.1424 30.487 26.8734C30.9694 26.6045 31.1423 25.9954 30.8734 25.513C29.947 23.8517 28.4736 22.5554 26.55 21.9464C28.5273 21.0237 29.9091 19.06 29.9091 16.7547C29.9091 13.5466 27.2331 11 24 11C22.2262 11 20.6201 11.7665 19.5316 12.9882C19.4349 14.2908 18.912 15.4748 18.1018 16.4011ZM24 13C21.8107 13 20.0909 14.711 20.0909 16.7547C20.0909 18.7985 21.8107 20.5095 24 20.5095C26.1893 20.5095 27.9091 18.7985 27.9091 16.7547C27.9091 14.711 26.1893 13 24 13Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.3021 6.30505C7.58199 6.30505 4.56621 9.32083 4.56621 13.041C4.56621 16.7611 7.58199 19.7769 11.3021 19.7769C15.0223 19.7769 18.0381 16.7611 18.0381 13.041C18.0381 9.32083 15.0223 6.30505 11.3021 6.30505ZM2.56621 13.041C2.56621 8.21626 6.47742 4.30505 11.3021 4.30505C16.1269 4.30505 20.0381 8.21626 20.0381 13.041C20.0381 17.2761 17.0244 20.8073 13.0246 21.6071C16.9814 22.1295 19.9306 24.4481 21.637 27.6079C21.8995 28.0938 21.7183 28.7005 21.2323 28.9629C20.7464 29.2254 20.1397 29.0442 19.8773 28.5582C18.2549 25.5543 15.3424 23.496 11.3021 23.496C7.26185 23.496 4.34934 25.5543 2.727 28.5582C2.46455 29.0442 1.85786 29.2254 1.37192 28.9629C0.885975 28.7005 0.704793 28.0938 0.967238 27.6079C2.67372 24.4481 5.6229 22.1295 9.57964 21.6071C5.57985 20.8073 2.56621 17.2761 2.56621 13.041Z"
            />
        </SvgStyled>
    );
};

export default UserGroup_lg;
